import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";





@Component({
  selector: 'app-control-linea-modal',
  templateUrl: './control-linea-modal.component.html',
  styleUrls: ['./control-linea-modal.component.css']
})
export class ControlLineaModalComponent implements OnInit {


 form: FormGroup;
 showSalida: number=1;
 //filtro_linea3: string= "uno";
 entrega: number;
 observaciones : any;


  @Input() closeMyModal: (any) => void;
  @Input() id_filtro_linea1: any;
  @Input() filtro_linea: any;
  @Input() tipo1: any;
  @Input() parametro1: any;
  //@Input() showSalida: any;
  @Output() salida: EventEmitter<any> = new EventEmitter();
  data=[];


  constructor(
    private formBuilder: FormBuilder
  ) {

  }

  ngOnInit(): void {
  }

  open(content) {
  this.data= [{
    filtro_linea: this.filtro_linea,
    tipo1: this.tipo1,
    parametro1: this.parametro1,
    id_filtro_linea1: this.id_filtro_linea1,
    entrega: this.entrega,
    observaciones: this.observaciones,
   }];
    this.salida.emit(this.data);
  }

}
